<template lang="pug">
  el-container
    el-header(height="auto")
      el-form(:model="form" inline label-suffix=":" ref="form")
        el-form-item(label="角色" prop="role")
          el-input(v-model="form.role")
        el-form-item(label="账号" prop="userName")
          el-input(v-model="form.userName")
        el-form-item(label="账号类型" prop="userType")
          el-select(v-model="form.userType" clearable)
            el-option(label="政府账号", :value="1")
            el-option(label="内部账号", :value="2")
        el-form-item(label="账号状态" prop="status")
          el-select(v-model="form.status" clearable)
            el-option(label="禁用", :value="0")
            el-option(label="启用", :value="1")
        el-form-item
          el-button(
            type="primary"
            icon="el-icon-search"
            :loading="searching"
            @click="search"
          ) 搜索
          reset-button(:remoteMethod="search")
          el-button(
            type="success"
            icon="el-icon-circle-plus"
            @click="add"
          ) 开通账号
    el-main
      grid(:remoteMethod="getTableData" ref="grid")
        el-table-column(prop="role" label="角色")
        el-table-column(:formatter="row => userTypeList[row.userType]" label="账号类型" width="100")
        el-table-column(prop="userName" label="账号")
        el-table-column(prop="password" label="密码")
        el-table-column(prop="createTime" label="创建时间")
        el-table-column(prop="lastLoginTime" label="最后登录时间")
        el-table-column(label="账号状态" width="70" align="center")
          template(slot-scope="scope")
            span.el-icon-success.green(v-if="scope.row.status")
            span.el-icon-remove.red(v-else)
        el-table-column(label="操作" width="220")
          template(slot-scope="scope")
            el-button(type="text" @click="edit(scope.row)") 修改账号
            el-button(
              type="text"
              @click="changeUserStatus(scope.row)"
            ) {{ scope.row.status ? '禁用' : '启用' }}账号
            el-button(type="text" v-if="scope.row.userType" @click="showPermission(scope.row)") 查看权限
      el-dialog(
        :title="`${user ? '修改' : '开通'}账号`"
        width="30%"
        :visible.sync="dialogVisible"
      )
        user-form(
          v-if="dialogVisible"
          :user="user"
          @submit="createSuccess"
        )
      el-dialog(
        title="账号权限"
        width="30%"
        :visible.sync="permissionDialogVisible"
      )
        permission-tree(:id="roleId" no-save v-if="permissionDialogVisible")
</template>

<script>
import { getUserList, changeUserStatus } from '@/api/user';
import grid from '@/components/grid';
import resetButton from '@/components/resetButton';
import userForm from './userForm';
import permissionTree from './permissionTree';

export default {
  name: 'UserList',
  components: {
    grid,
    userForm,
    permissionTree,
    resetButton
  },
  data() {
    return {
      form: {
        userName: '',
        role: '',
        userType: null,
        status: null
      },
      userTypeList: [
        '景区账号',
        '政府账号',
        '内部账号'
      ],
      userId: '',
      roleId: '',
      searching: false,
      dialogVisible: false,
      permissionDialogVisible: false,
      user: null
    };
  },
  mounted() {
    this.search();
  },
  methods: {
    async getTableData(data) {
      const res = await getUserList(data);
      return { data: res.data, total: res.total };
    },
    async search() {
      this.searching = true;
      await this.$refs.grid.loadData(this.form);
      this.searching = false;
    },
    showPermission(user) {
      this.roleId = user.role_id;
      this.permissionDialogVisible = true;
    },
    add() {
      this.user = null;
      this.dialogVisible = true;
    },
    edit(user) {
      this.user = user;
      this.dialogVisible = true;
    },
    createSuccess() {
      this.dialogVisible = false;
      this.search();
    },
    async changeUserStatus(user) {
      const data = {
        userId: user.userId,
        status: user.status ^ 1
      };
      const res = await changeUserStatus(data);
      if (res.status === 1) {
        this.$message.success('修改状态成功');
        this.search();
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.green{
  font-size: 18px;
  color: #67c23a;
}
.red{
  font-size: 18px;
  color: #dd454d;
}
</style>



// WEBPACK FOOTER //
// src/views/system/user.vue?87841bf2